/*

tiny editor config document
https://www.tiny.cloud/docs-4x/configure/

Full featured demo
https://www.tiny.cloud/docs/tinymce/6/full-featured-open-source-demo/

*/
import tinymce from 'tinymce/tinymce'

import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/models/dom';

import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';


import {
    Controller
} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.editorInit(this.element);
    }

    editorInit(element) {
        const toolbarLayout = element.getAttribute('data-toolbar');
        const toolbar = this.toolbarOption(toolbarLayout);
        const theme = this.element.getAttribute('data-theme');
        let apiPath = "/api/v1/upload_image";

        tinymce.init({
            selector: 'textarea.article-content',
            // base_url: '/assets/tinymce',
            plugins: 'link lists image media code table  ',
            toolbar: toolbar,
            toolbar_sticky: true,
            height: 1000,
            relative_urls: false, //圖片絕對路徑
            remove_script_host: true, //https://upload/xxx.jpg to /upload/xxx.jpg
            image_dimensions: false,
            media_dimensions: false,
            file_picker_types: 'image',
            content_css: false,
            skin: false,
            paste_as_text: true,
            link_rel_list: [{
                title: 'Current Window',
                value: ''
            }, {
                title: 'New Window',
                value: 'noopener noreferrer'
            }],
            extended_valid_elements: 'img[loading=lazy|decoding=async|src|alt|srcset|sizes|class|width|height]',
            file_picker_callback: (cb, value, meta) => {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');

                input.addEventListener('change', () => {
                    const reader = new FileReader();
                    const file = input.files[0];

                    reader.addEventListener('load', (e) => {
                        let uploadImg = e.target.result;

                        $.ajax({
                            url: apiPath,
                            type: 'POST',
                            data: {
                                image: uploadImg
                            }
                        }).done(function (result) {
                            /* call the callback and populate the Title field with the file name */
                            cb(result.image_url, {
                                title: file.name
                            });
                        }).fail(function (result) {});
                    });
                    reader.readAsDataURL(file);
                });

                input.click();
            },
            setup: function (editor) {
                editor.on('drop', function (e) {
                    e.preventDefault();
                    let files = e.dataTransfer.files;
                    let file = files[0];
                    if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: '請上傳圖片檔案',
                        })
                        return;
                    }
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function (e) {
                        let uploadImg = e.target.result;
                        $.ajax({
                            url: apiPath,
                            type: 'POST',
                            data: {
                                image: uploadImg
                            }
                        }).done(function (result) {
                            editor.insertContent('<img src="' + result.image_url + '" />');
                        }).fail(function (result) {});
                    };
                })
            },
            media_url_resolver: function (data, resolve) {
                let url = data.url;
                let videoid = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/)[1];
                let embedHtml = '<div class="ratio ratio-16x9"><iframe src="https://www.youtube.com/embed/' + videoid + '" allowfullscreen></iframe></div>';
                resolve({
                    html: embedHtml
                });
            }
        });
    }

    toolbarOption(toolbarLayout) {
        if (toolbarLayout == "full") {
            return "undo redo | blocks | bold italic underline strikethrough | align numlist bullist | link outdent indent | image media table | removeformat | code"
        } else {
            return "image table code"
        }
    }
}